import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Drawer from '../components/drawer';
import './index.css';
import LocalStorageHelper from '../helpers/local_storage';
import { getCrf } from '../actions/CrfOptions';
import { Avatar, Dropdown, Layout, Menu } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
const { Header, Content } = Layout;
export class NavigationLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hall_options: {}
		};
	}
	async componentDidMount() {
		await this.props.getCrf();
	}
	render() {
		const { location, history } = this.props.children.props;
		const { crf } = this.props.crfPageReducer;

		const menu = (
			<Menu style={{ background: '#003366', color: '#fff', marginTop: 10 }}>
				<Menu.Item
					className="dropdown-item-style"
					style={{ color: '#fff' }}
					icon={<LogoutOutlined />}
				>
					<Link
						to="/logout"
						style={{ color: 'white' }}
					// onClick={() => this.changeRoute('logout')}
					>
						<p>Logout</p>
					</Link>
				</Menu.Item>
			</Menu>
		);

		return (
			<Layout>
				<Drawer
					crf_options={crf}
					location={location}
					history={history}
					style={{position: 'absolute'}}
				/>
				<Layout>
					<Header style={{ height: 48, padding: 0, lineHeight: 2 }}>
						<div
							className="right-nav"
							style={{ boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)', height: 53, position: 'static' }}
						>
							<span style={{ marginRight: '40px' }}>
								<Dropdown overlay={menu}>
									<a
										href="!#"
										style={{ color: '#000' }}
										onClick={e => e.preventDefault()}
									>
										<Avatar style={{ color: '#60403b', backgroundColor: '#faa71b', marginRight: 5 }}>{LocalStorageHelper.getUsername()[0].toUpperCase()}</Avatar> {LocalStorageHelper.getEmail()}
									</a>
								</Dropdown>
							</span>
						</div>
					</Header>
					<Content>
						<div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', padding: '0px 0px 80px 0px' }}>{this.props.children}</div>
					</Content>
				</Layout>
			</Layout >
		);
	}
}

const mapsStateToProps = state => ({
	crfPageReducer: state.crfPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getCrf(options) {
		dispatch(getCrf(options));
	}
});

export default connect(mapsStateToProps, mapsDispatchToProps)(NavigationLayout);
